module.exports = __webpack_public_path__ + "static/img/point.3c45098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/pop/point.png
// module id = EfOH
// module chunks = 2